import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Contact from './pages/Contact'
import { ScrollProvider } from './ScrollContext';
import BookNow from './pages/BookNow'
import NotFound from './pages/NotFound'
export default function App() {
  return (
    <ScrollProvider>
    <div>
        <Header />
        <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/booknow' element={<BookNow/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
    </div>
    </ScrollProvider>
  )
}
